import React, { useState } from "react";
import NavBar from "../../home/home components/NavBar";
import { Link } from "react-router-dom";
import Footer from "../../home/home components/Footer";
import Floats from "../../home/home components/Floats";
import { Card, Modal } from "react-bootstrap";
import "./Results.css";

// ✅ Result Sheet
import ResultSheet from "../../../images/ResultSheet.png";

// ✅ I PU (puc1 folder)
// ✅ I PU (puc1 folder - ALL images)
import ipu1 from "../../../assets/img/2026/photos/puc1/1.jpg";
import ipu2 from "../../../assets/img/2026/photos/puc1/2.jpg";
import ipu3 from "../../../assets/img/2026/photos/puc1/3.jpg";
import ipu4 from "../../../assets/img/2026/photos/puc1/4.jpg";
import ipu5 from "../../../assets/img/2026/photos/puc1/5.jpg";
import ipu6 from "../../../assets/img/2026/photos/puc1/6.jpg";
import ipu7 from "../../../assets/img/2026/photos/puc1/7.jpg";

// ✅ II PU (photos folder)
import img1 from "../../../assets/img/2026/photos/1.jpg";
import img2 from "../../../assets/img/2026/photos/2.jpg";
import img3 from "../../../assets/img/2026/photos/3.jpg";
import img4 from "../../../assets/img/2026/photos/4.jpg";
import img5 from "../../../assets/img/2026/photos/5.jpg";
import img6 from "../../../assets/img/2026/photos/6.jpg";
import img7 from "../../../assets/img/2026/photos/7.jpg";
import img8 from "../../../assets/img/2026/photos/8.jpg";
import img9 from "../../../assets/img/2026/photos/9.jpg";
import img10 from "../../../assets/img/2026/photos/10.jpg";

const Result = () => {

  // 🔹 Data Arrays
  const iPUImages = [
    ipu1, ipu2, ipu3, ipu4, ipu5, ipu6, ipu7];
    const iiPUImages = [
    img1, img2, img3, img4, img5,
    img6, img7, img8, img9, img10
  ];

  // 🔹 Modal State
  const [show, setShow] = useState(false);
  const [selectedImg, setSelectedImg] = useState("");

  const handleShow = (img) => {
    setSelectedImg(img);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  return (
    <>
      <NavBar />

      {/* Breadcrumb */}
      <section className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/">Home</Link></li>
            <li>Results</li>
          </ol>
          <h2>Results</h2>
        </div>
      </section>

      {/* Main Section */}
      <section className="portfolio">
        <div className="container">

          <Card className="text-center shadow-sm">
            <Card.Header>
              <h4>Results</h4>
            </Card.Header>

            {/* ================= II PU FIRST ================= */}
            <Card className="m-3 shadow-sm">
              <Card.Body>

                <h4 className="fw-bold mb-4 text-success">II PU</h4>

                <div className="row">
                  {iiPUImages.map((img, i) => (
                    <div className="col-md-4 mb-4" key={i}>
                      <div
                        className="image-card"
                        onClick={() => handleShow(img)}
                      >
                        <img
                          src={img}
                          alt={`iipu-${i}`}
                          className="img-fluid rounded"
                        />
                      </div>
                    </div>
                  ))}
                </div>

              </Card.Body>
            </Card>

            {/* Divider */}
            <hr style={{ margin: "40px 0" }} />

            {/* ================= I PU SECOND ================= */}
            <Card className="m-3 shadow-sm">
              <Card.Body>

                <h4 className="fw-bold mb-4 text-primary">I PU</h4>

                <div className="row">
                  {iPUImages.map((img, i) => (
                    <div className="col-md-4 mb-4" key={i}>
                      <div
                        className="image-card"
                        onClick={() => handleShow(img)}
                      >
                        <img
                          src={img}
                          alt={`ipu-${i}`}
                          className="img-fluid rounded"
                        />
                      </div>
                    </div>
                  ))}
                </div>

              </Card.Body>
            </Card>

            {/* RESULT SHEET */}
            <Card.Body>
              <img
                src={ResultSheet}
                alt="Result Sheet"
                className="img-fluid"
                style={{
                  borderRadius: "10px",
                  marginTop: "20px"
                }}
              />
            </Card.Body>

          </Card>

        </div>
      </section>

      {/* 🔥 FULL SCREEN MODAL */}
      <Modal show={show} onHide={handleClose} centered size="xl">
        <Modal.Body style={{ padding: 0 }}>
          <img
            src={selectedImg}
            alt="Full View"
            className="img-fluid w-100"
          />
        </Modal.Body>
      </Modal>

      <Footer />
      <Floats />
    </>
  );
};

export default Result;